
export class TaskCard
{
    public assignee: string;
    public assigneeName: string;
    public assigneeTeamRole: string;
    public lateTasks: number;
    public assignedTasks: number;
    public nextTaskDueDate: Date;
    public nextTaskDueDateText: string;
    public orderUser: number;
    public isUnassigned: boolean;
    public tasks: any = [];
    public userRoleName: string;
}

export class TaskCardList
{
    public data: TaskCard[] = [];
}
